import React from 'react';
import { ReactComponent as  BlockIcon} from '../../../assets/icons/block.svg';


interface InitializationErrorScreenProps {
    classification: 'NETWORK_ERROR' | 'SERVER_ERROR' | 'CHUNK_ERROR' | 'UNKNOWN_ERROR';
}

const InitializationErrorScreen: React.FC<InitializationErrorScreenProps> = ({ classification }) => {
    const handleReload = () => {
        window.location.reload();
    };

    const getTitle = () => {
        switch (classification) {
            case 'NETWORK_ERROR':
                return 'Connection Interrupted';
            case 'SERVER_ERROR':
                return 'Server Maintenance';
            case 'CHUNK_ERROR':
                return 'App Update in Progress';
            default:
                return 'Unexpected Error';
        }
    };

    const getMessage = () => {
        switch (classification) {
            case 'NETWORK_ERROR':
                return 'We are having trouble connecting to our servers. Please check your internet connection.';
            case 'SERVER_ERROR':
                return 'Our servers are currently experiencing issues or undergoing maintenance.';
            case 'CHUNK_ERROR':
                return 'An application update is in progress. Please reload to fetch the latest version.';
            default:
                return 'An unexpected error occurred during application initialization.';
        }
    };

    return (
        <div className="container d-flex align-items-center justify-content-center vh-100">
            <div className="card text-center shadow-lg" style={{ maxWidth: '550px', width: '90%' }}>
                <div className="card-body p-5">
                    <div className="mb-4 text-warning">
                        <BlockIcon className="bc-icon" aria-hidden="true" />
                    </div>
                    <h1 className="mb-3 fw-bold card-title h2">{getTitle()}</h1>
                    <p className="mb-4 card-text opacity-75">{getMessage()}</p>
                    <div className="d-flex justify-content-center">
                        <button className="btn btn-primary px-4 py-2 rounded-pill" onClick={handleReload}>
                            Reload App
                        </button>
                    </div>
                </div>
            </div>
        </div>
  );
};

export default InitializationErrorScreen;
